







import Vue from 'vue';
import { I8Icon } from 'i8-ui';

// Icon library
import { faChevronLeft } from '@fortawesome/pro-light-svg-icons/faChevronLeft';

// Add all icons to the library
import { library } from '@fortawesome/fontawesome-svg-core';
library.add(faChevronLeft);

export const PrBackButton = Vue.extend({
  components: {
    I8Icon,
  },
});

export default PrBackButton;
